import { useState, useEffect } from 'react';
import { Form, Input, Button, message, Card, Divider, Space, Collapse } from 'antd';
import { PlusOutlined, MinusCircleOutlined, GlobalOutlined } from '@ant-design/icons';
import API from '../api/client';

const iconOptions = [
  'FaUtensils', 'FaUmbrellaBeach', 'FaShip', 'FaTruck', 'FaSeedling', 'FaBroom',
  'FaBuilding', 'FaHandshake', 'FaLeaf', 'FaUsers', 'FaHeart', 'FaStar',
  'FaGlobe', 'FaCog', 'FaLightbulb', 'FaShieldAlt',
];

const AboutPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get('/about').then((res) => {
      if (res.data && res.data._id) form.setFieldsValue(res.data);
    });
  }, [form]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      await API.put('/about', values);
      message.success('Kaydedildi');
    } catch { message.error('Hata oluştu'); }
    setLoading(false);
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Hakkımızda Ayarları</h2>
        <Button type="primary" onClick={handleSave} loading={loading}>Kaydet</Button>
      </div>

      <Form form={form} layout="vertical">
        <Collapse
          defaultActiveKey={['hero', 'story', 'mission']}
          items={[
            {
              key: 'hero',
              label: 'Hero Alanı',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['hero', 'badge']} label="Badge Metni">
                    <Input placeholder="Didim Belediyesi İştiraki" />
                  </Form.Item>
                  <Form.Item name={['hero', 'title']} label="Başlık">
                    <Input placeholder="Hakkımızda" />
                  </Form.Item>
                  <Form.Item name={['hero', 'description']} label="Alt Açıklama">
                    <Input placeholder="Didim'in geleceğine değer katmak için çalışıyoruz" />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'story',
              label: 'Biz Kimiz? Bölümü',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['story', 'year']} label="Kuruluş Yılı">
                    <Input placeholder="2019" style={{ width: 120 }} />
                  </Form.Item>
                  <Form.Item name={['story', 'title']} label="Başlık">
                    <Input placeholder="Biz Kimiz?" />
                  </Form.Item>
                  <Form.Item name={['story', 'paragraph1']} label="1. Paragraf">
                    <Input.TextArea rows={4} />
                  </Form.Item>
                  <Form.Item name={['story', 'paragraph2']} label="2. Paragraf">
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'mission',
              label: 'Misyonumuz Bölümü',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['mission', 'title']} label="Başlık">
                    <Input placeholder="Misyonumuz" />
                  </Form.Item>
                  <Form.Item name={['mission', 'paragraph1']} label="1. Paragraf">
                    <Input.TextArea rows={4} />
                  </Form.Item>
                  <Form.Item name={['mission', 'paragraph2']} label="2. Paragraf">
                    <Input.TextArea rows={4} />
                  </Form.Item>
                  <Form.Item name={['mission', 'paragraph3']} label="3. Paragraf">
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'sectors',
              label: 'Faaliyet Alanları',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['sectors', 'subtitle']} label="Üst Başlık">
                    <Input placeholder="Faaliyet Alanlarımız" />
                  </Form.Item>
                  <Form.Item name={['sectors', 'title']} label="Ana Başlık">
                    <Input placeholder="Hizmet Verdiğimiz Sektörler" />
                  </Form.Item>
                  <Divider>Sektör Kartları</Divider>
                  <Form.List name={['sectors', 'items']}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Card key={key} size="small" style={{ marginBottom: 12 }}
                            extra={<MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red' }} />}>
                            <Space style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }} align="start">
                              <Form.Item {...restField} name={[name, 'icon']} label="İkon">
                                <Input placeholder="FaUtensils" style={{ width: 160 }} />
                              </Form.Item>
                              <Form.Item {...restField} name={[name, 'title']} label="Başlık">
                                <Input placeholder="Kafe & Restoran" style={{ width: 200 }} />
                              </Form.Item>
                              <Form.Item {...restField} name={[name, 'desc']} label="Açıklama">
                                <Input placeholder="Yiyecek ve içecek hizmetleri" style={{ width: 300 }} />
                              </Form.Item>
                            </Space>
                          </Card>
                        ))}
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Sektör Ekle
                        </Button>
                      </>
                    )}
                  </Form.List>
                  <div style={{ marginTop: 12, fontSize: 12, color: '#999' }}>
                    Kullanılabilir ikonlar: {iconOptions.join(', ')}
                  </div>
                </Card>
              ),
            },
            {
              key: 'values',
              label: 'Değerlerimiz',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['values', 'subtitle']} label="Üst Başlık">
                    <Input placeholder="Değerlerimiz" />
                  </Form.Item>
                  <Form.Item name={['values', 'title']} label="Ana Başlık">
                    <Input placeholder="Bizi Biz Yapan İlkeler" />
                  </Form.Item>
                  <Divider>Değer Kartları</Divider>
                  <Form.List name={['values', 'items']}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Card key={key} size="small" style={{ marginBottom: 12 }}
                            extra={<MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red' }} />}>
                            <Space style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }} align="start">
                              <Form.Item {...restField} name={[name, 'icon']} label="İkon">
                                <Input placeholder="FaBuilding" style={{ width: 160 }} />
                              </Form.Item>
                              <Form.Item {...restField} name={[name, 'title']} label="Başlık">
                                <Input placeholder="Kurumsal Güven" style={{ width: 200 }} />
                              </Form.Item>
                              <Form.Item {...restField} name={[name, 'desc']} label="Açıklama">
                                <Input placeholder="Şeffaf ve güvenilir yönetim." style={{ width: 300 }} />
                              </Form.Item>
                            </Space>
                          </Card>
                        ))}
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Değer Ekle
                        </Button>
                      </>
                    )}
                  </Form.List>
                  <div style={{ marginTop: 12, fontSize: 12, color: '#999' }}>
                    Kullanılabilir ikonlar: {iconOptions.join(', ')}
                  </div>
                </Card>
              ),
            },
            {
              key: 'seo',
              label: <span><GlobalOutlined /> SEO Ayarları</span>,
              children: (
                <Card bordered={false}>
                  <Form.Item name={['seo', 'metaTitle']} label="Meta Başlık" extra="Tarayıcı sekmesinde ve arama sonuçlarında görünecek başlık">
                    <Input placeholder="Hakkımızda | Dihiz A.Ş." />
                  </Form.Item>
                  <Form.Item name={['seo', 'metaDescription']} label="Meta Açıklama" extra="Arama motorlarında görünecek açıklama (max 160 karakter)">
                    <Input.TextArea rows={2} placeholder="Dihiz A.Ş. hakkında bilgi edinin..." maxLength={160} showCount />
                  </Form.Item>
                  <Form.Item name={['seo', 'metaKeywords']} label="Anahtar Kelimeler" extra="Virgülle ayırarak yazın">
                    <Input placeholder="dihiz, didim, hakkımızda, belediye" />
                  </Form.Item>
                  <Form.Item name={['seo', 'ogImage']} label="OG Görsel URL" extra="Sosyal medyada paylaşıldığında görünecek görsel">
                    <Input placeholder="https://..." />
                  </Form.Item>
                </Card>
              ),
            },
          ]}
        />

        <div style={{ marginTop: 24, textAlign: 'right' }}>
          <Button type="primary" onClick={handleSave} loading={loading} size="large">Kaydet</Button>
        </div>
      </Form>
    </>
  );
};

export default AboutPage;
